import React, { useState } from "react";
import { uniqueId } from "lodash-es";
import SurveyFormItem from "../../Components/SurveyFormItem/SurveyFormItem";
import "text-security/text-security.css"
import SurveyInput from "../../Components/SurveyInput/SurveyInput";
import { format24HTimeToTimeAnswer, formatTimeAnswerToISOTime } from "../../Util/timeHelpers";
import { SurveyQuestionProps } from "../../Components/SurveyQuestion/SurveyQuestion";
import useTranslate from "../../../../hooks/useTranslate";
import { QuestionResultModel } from "../../../../types/SurveyResult";

export default function (props: SurveyQuestionProps) {
    let [inputID] = useState(uniqueId(props.result.Identifier));
    let defaultPlaceholder = useTranslate(["default-time-placeholder"])["default-time-placeholder"];
    let currentResult = props.result as QuestionResultModel;

    function answerChanged(answer: string) {
        props.onResultChange({ ...props.result, Answer: format24HTimeToTimeAnswer(answer) } as QuestionResultModel);
    }

    let time = currentResult.Answer ? formatTimeAnswerToISOTime(currentResult.Answer) : "";

    return <SurveyFormItem
        topBorder
        bottomBorder
        label={props.label}
        labelFor={inputID}
        labelPosition={props.labelPosition}
        variant={props.variant}
        index={props.index}>
        <SurveyInput id={inputID}
            value={time}
            type="time"
            placeholder={props.placeholder || defaultPlaceholder}
            onChange={(e) => answerChanged(e.target.value)}
            onEnterPressed={props.onEnterPressed}
            variant={props.variant} />
    </SurveyFormItem>
}